<template>
    <Select :options='subs' :value='sub' label="Subscription" @update:value='updateSub'>
        <template #option="{option}">
            <div class='flex items-center'>
                <IconZapoAdsLogo v-if="option.product_id == 1" class="w-4.5 h-4.5 mr-2.5" />
                <IconZapoCrmLogo v-if="option.product_id == 2" class=" w-4.5 h-4.5 mr-2.5" />
                <p>{{ option.html }}</p>
            </div>
        </template>
    </Select>

    <Select
        class='mt-4'
        label="Invoices"
        v-if='invoices.length > 0'
        :options='invoices'
        v-model:value="inv"
        @update:value='updateInv'
    >
        <template #option="{option}">
            <div class='text-left'>
                <p>{{ option.html }}</p>
                <p class='text-grey-900 text-14 !font-normal'>{{ option.second }}</p>
            </div>
        </template>
    </Select>
</template>

<script>
    export default {
        props: ['filter', 'page'],

        data() {
            return {
                sub: null,
                invoices: [],
                inv: null
            }
        },

        created() {
            let a = this.filter.values.find(f => f.id == this.page.user.filters[this.filter.name])
            this.sub = a.company_id+'-'+a.location_id
            this.setInvoices()

            this.inv = this.invoices[0].value
        },
        
        methods: {
            updateSub(value) {
                this.sub = value
                this.setInvoices();
                this.inv = this.invoices[0].value

                this.page.filterOverrides[this.filter.name].change(this.filter, this.inv);
                this.page.call().updated()
            },

            updateInv(value) {
                this.inv = value
                this.page.filterOverrides[this.filter.name].change(this.filter, this.inv);
                this.page.call().updated()
            },

            setInvoices() {
                this.invoices = this.filter.values.filter(f => {
                    return f.company_id+'-'+f.location_id == this.sub
                })
                    .map((v) => ({ 
                        html: this.$moment(v.ads_period_from).format('DD/MM/YYYY') + ' - ' + this.$moment(v.ads_period_to).format('DD/MM/YYYY'),
                        value: v.id
                    }))
            }
        },

        computed: {
            subs() {
                return this.filter.values
                    .reduce((acc, current) => {
                        if (!acc.some(item => item.second_line === current.second_line)) {
                            acc.push(current);
                        }
                        return acc;
                    }, [])
                    .map((v) => ({ 
                        html: v.second_line,
                        value: v.company_id+'-'+v.location_id,
                        product_id: v.product_id
                    }))
            },
        }
    }
</script>
